<template>
  <div id="logindiv">
    <img src="../assets/logo.png" alt="image">
    <h1>Brains</h1>
    <button type="button" class="brains-type1-btn" @click="login">{{ $t("login.loginbtn") }}</button>
    <!--<p v-if="loginFailed">{{ $t("login.loginerror") }}</p>-->
  </div>
</template>

<script>
import AuthService from '@/services/auth.service'
export default {
  name: 'Login',
  data() {
    return {
      loginFailed: false
    }
  },
  created() {
    this.authService = new AuthService()
  },
  methods: {
    login() {
      document.location.href = '/'
      /*
      const vm = this
      vm.$store.dispatch('user/login').then(() => {
        vm.loginFailed = false
        vm.$store.dispatch('user/gettoken').then(() => {
          if (vm.$route.query.latitude && vm.$route.query.longitude) {
            document.location.reload()
          }
        })
      }).catch(() => {
        vm.loginFailed = true
      })
      */
    }
  }
}
</script>

<style>
  #logindiv {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
